namespace GeniuzPOS.PosShift {
    export namespace LookupLastPassportDataforVatRefundService {
        export const baseUrl = 'PosShift/LookupLastPassportDataforVatRefund';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupLastPassportDataforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupLastPassportDataforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/LookupLastPassportDataforVatRefund/Retrieve",
            List = "PosShift/LookupLastPassportDataforVatRefund/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupLastPassportDataforVatRefundService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
